const DROP_DOWN_LIMIT = 100;

export default DROP_DOWN_LIMIT;
